export default {
  watch: {
    inherit: function(newVal, oldVal) {
      if (newVal === true) {
        this.temporaryInnerValue = this.innerValue
        this.innerValue = this.inheritValue
      } else {
        this.innerValue =
          this.temporaryInnerValue !== '' ? this.temporaryInnerValue : this.inheritValue
      }
    },
  },
  computed: {
    fieldError() {
      const item = {
        settingKey: this.innerSetting.SettingKey,
        error: false,
      }

      if (this.$v.innerValue.$invalid && this.inherit === false) {
        item.error = true
        this.$bus.$emit('updateFormErrors', item)

        return `${this.innerSetting.DisplayName} is required`
      }

      if (this.isSelectedItemIsMissing && this.inherit === false) {
        item.error = true
        this.$bus.$emit('updateFormErrors', item)

        return `Option is missing (${this.isSelectedItemIsMissing.Value})`
      }

      this.$bus.$emit('updateFormErrors', item)
      return null
    },
  },
}
